import React, { FC, Suspense, useMemo } from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { useRoutes } from './Routes';
import { FullPageLayoutLoader } from '../FullPageLayoutLoader/FullPageLayoutLoader';
import OpenInMobileAppConditionalContainer from '../OpenInMobileApp/OpenInMobileAppConditionalContainer';

const Router: FC = () => {
  const { routesObject } = useRoutes();

  const browserRouter = useMemo(
    () => createBrowserRouter(routesObject),
    [routesObject],
  );

  return (
    <OpenInMobileAppConditionalContainer>
      <Suspense fallback={<FullPageLayoutLoader />}>
        <RouterProvider router={browserRouter} />
      </Suspense>
    </OpenInMobileAppConditionalContainer>
  );
};

export default Router;
